import React, { useEffect, useState } from "react";
import axios from "axios";
import "./subvideo.css";
import { Link } from "react-router-dom";
import nodata from "../../assets/nodatafound.jpg";

function Mom3({ selectedTool, setSelectedTool }) {
  const [videoData, setVideoData] = useState([]);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const videosPerPage = 9;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          "https://periodscalendar.preggyzone.com/api/Video/video_list_by_category_id",
          { video_category_id: 6 }
        );

        if (Array.isArray(response.data.data)) {
          setVideoData(response.data.data);
        } else {
          setVideoData(response.data.data.videos || []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Handle video click for overlay
  const handleVideoClick = (videoUrl) => {
    if (videoUrl) {
      let youtubeEmbedUrl = videoUrl.includes("watch?v=")
        ? videoUrl.replace("watch?v=", "embed/")
        : videoUrl.includes("/shorts/")
        ? videoUrl.replace("/shorts/", "/embed/")
        : null;

      if (youtubeEmbedUrl) {
        setSelectedVideoUrl(youtubeEmbedUrl);
      } else {
        console.error("Unsupported video URL format:", videoUrl);
      }
    }
  };

  const handleCloseVideo = () => {
    setSelectedVideoUrl(null);
  };

  // **Pagination Logic**
  const startIndex = currentPage * videosPerPage;
  const paginatedVideos = videoData.slice(
    startIndex,
    startIndex + videosPerPage
  );

  const handleNextPage = () => {
    if (startIndex + videosPerPage < videoData.length) {
      setCurrentPage(currentPage + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="dietchart-base">
      <div className="diet-chart">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/videos" className="breadcrumb-link">
                  Videos
                </Link>
              </li>
              <li className="breadcrumblist active">MomTrimester3</li>
            </ol>
          </nav>
        </div>
        <h1
          className="head-do-h1"
          style={{
            textAlign: "center",
            marginBottom: "30px",
            textTransform: "initial",
            color: "#B24C76",
          }}
        >
          Do's for mom during third trimester
        </h1>

        {/* Video Grid */}
        <div className="video-grid">
          {paginatedVideos.length > 0 ? (
            paginatedVideos.map((item, index) => (
              <div
                key={index}
                className="video-itemm"
                onClick={() => handleVideoClick(item.video_url)}
              >
                <img
                  src={item.video_thumb_img_url}
                  className="video-image"
                  alt="Video Thumbnail"
                />
              </div>
            ))
          ) : (
            <>
              <div></div>
              <div className="ndf-container">
                <img src={nodata} alt="No-Data-Found" id="no-data-found" />
                <h4>No Videos Found</h4>
              </div>
              <div></div>
            </>
          )}
        </div>

        {/* Pagination Controls - Show Only If Data Exists */}
        {paginatedVideos.length > 0 && (
          <div className="pagination-buttons">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 0}
              id="prev-vid"
            >
              Previous
            </button>
            <button
              onClick={handleNextPage}
              disabled={startIndex + videosPerPage >= videoData.length}
              id="nex-vid"
            >
              Next
            </button>
          </div>
        )}

        {/* Video Overlay */}
        {selectedVideoUrl && (
          <div className="video-overlay">
            <button className="close-button" onClick={handleCloseVideo}>
              &times;
            </button>
            <div className="overlay-content">
              <iframe
                width="100%"
                height="400"
                src={selectedVideoUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Mom3;
